import { render } from "./TournamentDetails.vue?vue&type=template&id=1adae244"
import script from "./TournamentDetails.vue?vue&type=script&lang=js"
export * from "./TournamentDetails.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mobitel/quizgiri/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__